import { getNominationsClientBaseUrl } from '../utils/environmentUrls.js';

const parseUrlParams = () => new URLSearchParams(window.location.search)

export const getOrgName = () => {
  const urlParams = parseUrlParams()
  return urlParams.get('org_name') || ''
}

const getInvitationUuid = () => {
  const urlParams = parseUrlParams()
  return urlParams.get('invitation_uuid') || ''
}

const getUtms = () => {
  const urlParams = parseUrlParams()
  const utms = new URLSearchParams()
  urlParams.forEach((value, key) => {
    key.includes('utm') && utms.append(key, value)
  })
  return utms.toString()
}

export const getAcceptNominationUrl = () => {
  const baseUrl = getNominationsClientBaseUrl()
  const invitationUuid = getInvitationUuid()
  const utms = getUtms()
  return `${baseUrl}/nomination/${invitationUuid}?${utms}`
}
